/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 * React 19 compatible version using SimpleFileBrowser
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SimpleFileBrowser from './SimpleFileBrowser';

/**
 * Formats S3 files for SimpleFileBrowser
 * The formatting we should (maybe) keep?
 */
function getFileListAndFormat(baseKey, awsS3Files) {
    let files = [];
    // Extract base path by removing domain and leading slash
    const basePath = baseKey.split('/').slice(1).join('/');
    if (awsS3Files != null && awsS3Files.length > 0) {
        for (let contentKey in awsS3Files) {
            let file = awsS3Files[contentKey];
            files.push({
                // Strip out the base key from the prefix
                id: file.Prefix,
                path: file.Prefix,
                name: file.Prefix.replace(basePath, '').replace(/^\//, ''),
                isDirectory: true
            });
        }
    }
    return files;
}

export const FileTreeBrowser = (props) => {
    const {
        baseKey,
        files,
        onFileAction
    } = props;

    const [selectedFile, setSelectedFile] = useState(null);

    const _files = getFileListAndFormat(baseKey, files);

    const handleFileSelect = (selectedFiles) => {
        if (selectedFiles && selectedFiles.length > 0) {
            const selectedPath = selectedFiles[0];
            setSelectedFile(selectedPath);
            // Find the file object to get the full id (Prefix)
            const selectedFileObj = _files.find(f => f.path === selectedPath);
            if (selectedFileObj && onFileAction) {
                // Call onFileAction with the file object matching the expected API
                onFileAction({ id: selectedFileObj.id, name: selectedFileObj.name });
            }
        }
    };

    return (
        <div style={{ 
            height: '100%', 
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #dee2e6',
            borderRadius: '0.375rem',
            overflow: 'hidden'
        }}>
            <SimpleFileBrowser
                files={_files}
                onFileSelect={handleFileSelect}
                selectedFiles={selectedFile ? [selectedFile] : []}
                singleSelection={true}
                showSearch={true}
                style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
            />
        </div>
    );
};

FileTreeBrowser.propTypes = {
    baseKey: PropTypes.string.isRequired,
    files: PropTypes.array.isRequired,
    onFileAction: PropTypes.func.isRequired
};

export default FileTreeBrowser;
